import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { FlexLayout, ThemeContext } from '@gv/triage-components';

import { DynamicActionButtonProps } from './types';
import {
  Divider,
  Subtitle,
  Container,
  MainButton,
  ActionButton,
} from './styles';

export const DynamicActionButton = ({
  icon,
  title,
  subtitle,
  mainPath,
  actionIcon,
  actionPath,
  isComingSoon = false,
}: DynamicActionButtonProps): JSX.Element => {
  const navigate = useNavigate();
  const { isDarkTheme } = useContext(ThemeContext);

  const handleActionClick = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    if (actionPath) {
      navigate(actionPath);
    }
  };

  return (
    <Container>
      <MainButton
        to={mainPath}
        $hasAction={!!actionIcon}
        $isComingSoon={isComingSoon}
      >
        <FlexLayout gap={8} alignItems="center">
          {icon}
          <FlexLayout gap={8} alignItems="center">
            <p>{title}</p>
            {subtitle && <Subtitle>{subtitle}</Subtitle>}
          </FlexLayout>
        </FlexLayout>
      </MainButton>

      {actionIcon && (
        <>
          <Divider isDarkTheme={isDarkTheme} />
          <ActionButton
            onClick={handleActionClick}
            $isComingSoon={isComingSoon}
          >
            {actionIcon}
          </ActionButton>
        </>
      )}
    </Container>
  );
};

export default DynamicActionButton;
